// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__BWGy2","rotating":"Spinner_rotating__+tQ4O","spinnerSm":"Spinner_spinnerSm__LEKhM"};